import qs from 'query-string'
import moment from 'moment'
import trans from 'counterpart'
import { buildParams } from '../modules/preferences/utilities'
import { getOffers } from '../api/offerApi'
import { setFilter } from './filterActions'
import { INTERNAL_DATE } from '../constants/dates'
import { PREFERENCE_KINDS, PREFERENCE_SUBJECTS } from '../constants/preferences'
import { newCancellationToken, isCancellationError } from '../utilities/api'
import { APP_DIERENBOS } from '../constants/apps'
import { getParams } from '../selectors/preferenceSelectors'

export const CLEAR_REFINE_PREFERENCES = 'preference/CLEAR_REFINE_PREFERENCES'
export const MERGE_PREFERENCES = 'preference/MERGE_PREFERENCES'
export const SET_ARRIVAL_PREFERENCE = 'preference/SET_ARRIVAL_PREFERENCE'
export const SET_PREFERENCE = 'preference/SET_PREFERENCE'

export const setPreference = (name, value) => ({
  type: SET_PREFERENCE,
  payload: {
    name,
    value
  }
})

let cancellationToken = null

export const fetchOffers = (focus = {}) => (dispatch, getState) => {
  const params = buildParams(getParams(focus)(getState()))

  if (cancellationToken) {
    cancellationToken.cancel('Cancelling offer fetch in favor of new request')
  }

  params.locale = trans('locale')
  if (cancellationToken) cancellationToken.cancel('Cancelling offer fetch in favor of new request')

  cancellationToken = newCancellationToken()
  if (process.env.RAZZLE_APP === APP_DIERENBOS) {
    params.resorts = [22]
  }

  return getOffers(params, cancellationToken.token)
    .then(({ data }) => {
      cancellationToken = null
      // If a departure date is available, the arrivals & departures are filled in a seperate function.
      if (!params.departure && !data.panic) {
        dispatch(setFilter('arrivals', (data.arrivals || []).map(date => moment(date).format(INTERNAL_DATE))))
        dispatch(setFilter('departures', (data.departures || []).map(date => moment(date).format(INTERNAL_DATE))))
      }

      dispatch(setFilter('properties', Array.isArray(data.properties) ? {} : data.properties || {}))
      dispatch(setFilter('resorts', Array.isArray(data.resorts) ? {} : data.resorts || {}))
      dispatch(setFilter('kinds', Array.isArray(data.kinds) ? {} : data.kinds || {}))

      const state = getState()
      if (data.results && data.results.length && data.results[0].arrival_date) {
        if (state.preferences.arrival !== data.results[0].arrival_date) {
          // Update the arrival if the arrival date in the result has changed (e.g. because of a re-fetch on the backend)
          dispatch(setPreference('arrival', data.results[0].arrival_date))
        }
        // This is being disabled for now, since it introduced a bug where the first day after the arrival day was not clickable as departure
        // if (params.resource) {
        //   // Set the departure date preference when searching availability for a single item
        //   dispatch(setPreference('departure', data.results[0].departure_date));
        // }
      }

      if ((data.params || {}).kinds) {
        dispatch(setPreference(PREFERENCE_KINDS, data.params.kinds.map(kind => parseInt(kind, 10))))
      }

      if ((data.params || {}).subjects) {
        dispatch(setPreference(PREFERENCE_SUBJECTS, data.params.subjects.reduce((subjectObject, subject) => {
          const parts = subject.split('-')
          subjectObject[parts[0]] = parts[1]
          return subjectObject
        }, {})))
      }

      return data
    })
    .catch((err) => {
      if (!isCancellationError(err)) {
        cancellationToken = null
        throw err
      }
    })
}

let arrivalsAndDeparturesCancellationToken = null

export const fetchArrivalsAndDepartures = (focus = {}) => (dispatch, getState) => {
  const params = buildParams(getParams(focus)(getState()))
  if (!params.departure) return null
  delete params.departure
  if (process.env.RAZZLE_APP === APP_DIERENBOS) params.resorts = [22]
  if (arrivalsAndDeparturesCancellationToken) arrivalsAndDeparturesCancellationToken.cancel('Cancelling offer fetch in favor of new request')
  arrivalsAndDeparturesCancellationToken = newCancellationToken()

  return getOffers(params, arrivalsAndDeparturesCancellationToken.token)
    .then(({ data }) => {
      arrivalsAndDeparturesCancellationToken = null
      dispatch(setFilter('arrivals', data.arrivals))
      dispatch(setFilter('departures', data.departures))
      return data
    })
    .catch((err) => {
      if (!isCancellationError(err)) {
        arrivalsAndDeparturesCancellationToken = null
      }
    })
}

export const clearRefinePreferences = () => ({
  type: CLEAR_REFINE_PREFERENCES
})

export const setArrivalPreference = arrival => ({
  type: SET_ARRIVAL_PREFERENCE,
  payload: arrival
})

export const mergePreferences = preferences => ({
  type: MERGE_PREFERENCES,
  payload: preferences
})

/**
 * Updates the url with search parameters
 */
export const updateQueryString = (property, value) => (dispatch, getState) => {
  const params = { ...getState().preferences }

  if (property && value) params[property] = value

  if (params.subjects) {
    params.subjects = Object.keys(params.subjects)
      .filter(subjectId => params.subjects[subjectId] > 0)
      .map(subjectId => `${subjectId}-${params.subjects[subjectId]}`)
  }

  Object.keys(params).forEach(key => !params[key] && delete params[key])

  delete params.display
  delete params.locale

  const result = qs.stringify(params, { arrayFormat: 'bracket' })
  window.history.pushState(null, null, `${window.location.protocol}//${window.location.host}${window.location.pathname}?${result}`)
}
